import { request } from "./api";

export type BulkOpAction = "hide" | "show" | "make_free" | "make_premium" | "archive" | "restore" | "move";

export type HistoryEntry = {
  id: string;
  action: string;
  title: string;
  by: string | null;
  at: string | null;
  details?: Record<string, unknown> | null;
};

const post = <T>(path: string, token: string, body?: unknown) =>
  request<T>(path, { method: "POST", body: body === undefined ? undefined : JSON.stringify(body) }, token);

export const adminResourceOpsApi = {
  archive: (token: string, id: string) => post<{ ok: boolean }>(`/admin/resources/${id}/archive`, token),
  restore: (token: string, id: string) => post<{ ok: boolean }>(`/admin/resources/${id}/restore`, token),
  rename: (token: string, id: string, title: string) =>
    post<{ ok: boolean; title: string }>(`/admin/resources/${id}/rename`, token, { title }),
  duplicate: (token: string, id: string) => post<{ ok: boolean; id: string }>(`/admin/resources/${id}/duplicate`, token),
  move: (token: string, id: string, courseId: string) =>
    post<{ ok: boolean }>(`/admin/resources/${id}/move`, token, { course_id: courseId }),
  history: (token: string, id: string) =>
    request<{ items: HistoryEntry[] }>(`/admin/resources/${id}/history`, {}, token),
  bulk: (token: string, ids: string[], action: BulkOpAction, courseId?: string) =>
    post<{ ok: boolean; count: number; skipped: { id: string; reason: string }[] }>(
      "/admin/resources/bulk-ops",
      token,
      { ids, action, course_id: courseId },
    ),
};
